import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../shapes/Spinner';
import { silver } from '../colors';
const getSpinnerSizeString = spinnerSize => (spinnerSize >= 72 ? 'large' : spinnerSize >= 38 ? 'medium' : 'small');
export default class CarouselLoading extends PureComponent {
    render() {
        const { size } = this.props;
        const spinnerSize = size / 3;
        return (React.createElement("div", { className: "item active", style: {
                backgroundColor: silver,
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            React.createElement("div", { style: { height: spinnerSize } },
                React.createElement(Spinner, { size: getSpinnerSizeString(spinnerSize) }))));
    }
}
CarouselLoading.propTypes = {
    size: PropTypes.number,
};
